import { render, staticRenderFns } from "./gift-vouchers.vue?vue&type=template&id=7d515447"
import script from "./gift-vouchers.vue?vue&type=script&lang=js"
export * from "./gift-vouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftVoucher: require('/home/runner/work/platform/platform/packages/client/src/components/elements/vouchers/GiftVoucher.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
